import {useSelector, useDispatch} from 'react-redux'
import {useCallback} from 'react'
import {
  selectUseCases,
  selectIsSnackBarOpen,
  selectSnackbarMessage,
  setUseCases as setUseCasesAction,
  setIsSnackBarOpen as setIsSnackBarOpenAction,
  setSnackbarMessage as setSnackbarMessageAction
} from '../slices/useCaseSlice'

export const useUseCases = () => {
  const dispatch = useDispatch()
  const useCases = useSelector(selectUseCases)
  const isSnackBarOpen = useSelector(selectIsSnackBarOpen)
  const snackbarMessage = useSelector(selectSnackbarMessage)

  const setUseCases = useCallback(
    (value) => {
      dispatch(setUseCasesAction(value))
    },
    [dispatch]
  )

  const setIsSnackBarOpen = useCallback(
    (value) => {
      dispatch(setIsSnackBarOpenAction(value))
    },
    [dispatch]
  )

  const setSnackbarMessage = useCallback(
    (value) => {
      dispatch(setSnackbarMessageAction(value))
    },
    [dispatch]
  )

  return {
    useCases,
    setUseCases,
    isSnackBarOpen,
    setIsSnackBarOpen,
    snackbarMessage,
    setSnackbarMessage
  }
}
